import type { DemoKey } from '../types';

export const fa: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'ریاضی · آمار',
  'app.title': 'آمار',
  'panel.experiment': 'صحنه',
  'panel.params': 'پارامترها',

  'exp.survey-explorer.title': 'کاوشگر پرسش‌نامه',
  'exp.survey-explorer.desc': 'یک ستون انتخاب کن؛ نسخهٔ نمایشی خلاصهٔ مناسب را برمی‌گزیند.',
  'exp.distribution-sculptor.title': 'پیکرتراش توزیع',
  'exp.distribution-sculptor.desc': 'نقاط را بکش و واکنش آمار را ببین.',
  'exp.two-variable-lab.title': 'آزمایشگاه دو متغیّره',
  'exp.two-variable-lab.desc': 'پراکنش، برازش و پرسش علیت.',
  'exp.sampling-lab.title': 'آزمایشگاه نمونه‌گیری',
  'exp.sampling-lab.desc': 'چگونگی تأثیر روش و اندازه بر میانگین نمونه.',
  'exp.probability-diagrams.title': 'نمودارهای احتمال',
  'exp.probability-diagrams.desc': 'نمای ون و درختی برای رویدادهای مرکب.',

  'type.qualitative-nominal.label': 'کیفی · اسمی',
  'type.qualitative-nominal.def': 'دسته‌بندی‌های بدون ترتیب ذاتی.',
  'type.qualitative-ordinal.label': 'کیفی · ترتیبی',
  'type.qualitative-ordinal.def': 'دسته‌بندی‌های با ترتیب معنادار.',
  'type.qualitative-multi.label': 'کیفی · چندمقداری',
  'type.qualitative-multi.def': 'هر مشاهده می‌تواند چند برچسب داشته باشد.',
  'type.quantitative-discrete.label': 'کمی · گسسته',
  'type.quantitative-discrete.def': 'اعداد با گام ثابت.',
  'type.quantitative-continuous.label': 'کمی · پیوسته',
  'type.quantitative-continuous.def': 'اعداد روی مقیاس پیوسته.',

  'column.name.label': 'نام دانش‌آموز',
  'column.height_cm.label': 'قد',
  'column.shoe_size_eu.label': 'سایز کفش (EU)',
  'column.study_hours.label': 'ساعت مطالعه / هفته',
  'column.test_score.label': 'نمرهٔ امتحان',
  'column.sports_played.label': 'ورزش‌های انجام‌شده',
  'column.eye_color.label': 'رنگ چشم',
  'column.commute_min.label': 'رفت‌وآمد',
  'column.grade_year.label': 'پایه',
  'column.homework_effort.label': 'تلاش در تکلیف',
  'column.ice-cream-sales.label': 'فروش بستنی',
  'column.drownings.label': 'غرق‌شدگی‌ها',
  'column.month.label': 'ماه',
  'column.storks.label': 'لک‌لک‌ها',
  'column.births.label': 'تولّدها',
  'column.country_area_km2.label': 'مساحت کشور',
  'column.sleep_hours.label': 'ساعت خواب',
  'column.reaction_ms.label': 'زمان واکنش',

  'dataset.master-survey.label': 'پرسش‌نامهٔ کلاسی',
  'dataset.master-survey.desc': '۳۰ دانش‌آموز شبیه‌سازی‌شده.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'فروش بستنی در برابر غرق‌شدگی',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'هر دو با فصل بالا و پایین می‌روند. غرق‌شدگی علت فروش بستنی نیست.',
  'dataset.spurious-storks-vs-births.label': 'لک‌لک در برابر تولّد',
  'dataset.spurious-storks-vs-births.desc':
    'کشورهای بزرگ‌تر لک‌لک و تولّد بیشتری دارند. پرندگان علت نیستند.',
  'dataset.real-sleep-vs-reaction-time.label': 'خواب در برابر زمان واکنش',
  'dataset.real-sleep-vs-reaction-time.desc':
    'خواب بیشتر، واکنش سریع‌تر. همبستگی منفی واقعی — با سازوکار قابل قبول.',

  'tag.football.label': 'فوتبال',
  'tag.basketball.label': 'بسکتبال',
  'tag.volleyball.label': 'والیبال',
  'tag.swimming.label': 'شنا',
  'tag.none.label': 'هیچ‌کدام',

  'population.gaussian.label': 'منحنی زنگی',
  'population.right-skewed.label': 'چوله به راست',
  'population.bimodal.label': 'دومُده (با طبقات)',
  'population.uniform.label': 'یکنواخت',

  'venn.dice-even-or-prime.label': 'تاس: زوج یا اول',
  'venn.class-sports-2set.label': 'ورزش (۲ مجموعه)',
  'venn.class-sports-3set.label': 'ورزش (۳ مجموعه)',
  'venn.custom.label': 'سفارشی',

  'tree.draw-without-replacement.label': 'برداشت بدون جایگزینی',
  'tree.custom.label': 'سفارشی',
  'tree.coin.heads': 'ش',
  'tree.coin.tails': 'خ',
  'tree.draw.start': 'کیسه: ۲ قرمز، ۳ آبی',
  'tree.draw.red': 'قرمز',
  'tree.draw.blue': 'آبی',
  'tree.custom.start': 'شروع',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'هیستوگرام',
  'card.cumulative': 'فراوانی تجمعی',
  'card.box': 'جعبه‌ای',
  'card.summary': 'خلاصهٔ پنج‌عددی',
  'card.bar': 'نمودار میله‌ای',
  'card.mode': 'مُد',
  'card.tag-frequency': 'فراوانی برچسب',
  'card.mode-tag': 'برچسب پرتکرار',
  'card.empty-no-order': 'قابل اعمال نیست',
  'card.empty-multi': 'قابل اعمال نیست',
  'card.numberline': 'خط اعداد',
  'card.scatter': 'پراکنش',
  'card.description': 'چه می‌گذرد',
  'card.population': 'جامعه',
  'card.sampling-distribution': 'میانگین‌های نمونه',
  'card.venn': 'ون',
  'card.tree': 'درخت',
  'card.probabilities': 'احتمال‌ها',

  'param.dataset.label': 'مجموعه‌داده',
  'param.column.label': 'ستون',
  'param.bins.label': 'گروه‌ها',
  'param.shape.label': 'شکل اولیه',
  'param.show-mean.label': 'نمایش میانگین',
  'param.show-median.label': 'نمایش میانه',
  'param.x-col.label': 'ستون X',
  'param.y-col.label': 'ستون Y',
  'param.show-regression.label': 'خط رگرسیون',
  'param.show-residuals.label': 'باقی‌مانده‌ها',
  'param.show-confounder.label': 'نمایش متغیر مزاحم',
  'param.population.label': 'جامعه',
  'param.technique.label': 'روش',
  'param.sample-size.label': 'حجم نمونه',
  'param.stratum.label': 'لایه',
  'param.bias.label': 'سوگیری',
  'param.mode.label': 'حالت',
  'param.preset.label': 'پیش‌تنظیم',
  'param.universe.label': 'اندازهٔ کل',
  'param.show-prob.label': 'نمایش احتمال‌ها',
  'param.treat-as-numeric.label': 'به‌عنوان عددی',

  'stat.count': 'تعداد',
  'stat.mean': 'میانگین',
  'stat.median': 'میانه',
  'stat.range': 'دامنه',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'دورافتاده‌ها',
  'stat.r': 'r پیرسون',
  'stat.r2': 'r²',
  'stat.slope': 'شیب',
  'stat.intercept': 'عرض از مبدأ',
  'stat.n': 'n',
  'stat.population-mean': 'میانگین واقعی',
  'stat.latest-sample-mean': 'میانگین نمونه',
  'stat.sample-mean-spread': 'انحراف میانگین نمونه',
  'stat.sample-count': 'نمونه‌های گرفته‌شده',
  'outlier.upper': 'دورافتاده‌های بالایی',
  'outlier.lower': 'دورافتاده‌های پایینی',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'نمونه‌گیری مجدد',
  'btn.run-100': '۱۰۰ نمونه بگیر',
  'btn.stop': 'توقف',
  'btn.clear-history': 'پاک‌سازی تاریخچه',

  'explainer.no-order': 'بدون ترتیب → نه تجمعی، نه جعبه.',
  'explainer.multi-no-iqr': 'چندمقداری → چارک‌ها / IQR تعریف نشده.',
  'message.no-data': 'داده‌ای نیست.',
  'message.needs-quartiles': 'برای چارک‌ها ≥۴ نقطه لازم است.',
  'message.x-zero-variance': 'واریانس X صفر است — خطی برای برازش وجود ندارد.',
  'message.n-too-small': 'n بسیار کوچک است.',
  'message.stratum-clamp': 'لایه ردیف کمتری از خواسته داشت — همه استفاده شد.',
  'message.siblings-sum-to-one': 'مجموع فرزندان باید ۱ شود.',
};
